import mapboxgl from "mapbox-gl";

export default {
    name: 'map',
    component() {
        return {
            map: "",

            init() {},

            setMap() {
                mapboxgl.accessToken = "pk.eyJ1Ijoiam9lcmlldmVycyIsImEiOiJjazl6ZDR3OGgwNW5lM2VwbXJveHp2b3U5In0.Aj-tn3yoSlKVmpoDjhnMLw";
                // mapboxgl.accessToken = "";
        
                let center = [5.5949333, 51.1405788];
        
                this.map = new mapboxgl.Map({
                    container: "map", // container ID
                    style: "mapbox://styles/mapbox/light-v11", // style URL
                    center: center, // starting position [lng, lat]
                    zoom: 15, // starting zoom
                });
        
                setTimeout(() => {
                this.map.scrollZoom.disable();
        
                const el = document.querySelector("[data-marker]");
                new mapboxgl.Marker(el)
                    .setLngLat([5.597521695501652, 51.1406204798023])
                    .addTo(this.map);
        
                }, 200);
                // this.$root.classList.remove("opacity-0");
        
                setTimeout(() => {
                    this.map.resize();
                }, 200);
            },
        }
    }
}